module.exports = __webpack_public_path__ + "static/media/block-icons.ec4bd767.svg";